// extracted by mini-css-extract-plugin
export default {"premiumPublicationSearchFilter":"styles-module__premiumPublicationSearchFilter___N0WeU","cross":"styles-module__cross___F7g1v"};